import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill={ fill || 'currentColor' } />
        <path d="M14.73 7.94L12 10.67L9.27 7.94L7.94 9.27L10.67 12L7.94 14.73L9.27 16.06L12 13.33L14.73 16.06L16.06 14.73L13.33 12L16.06 9.27L14.73 7.94Z" fill={ fill || 'currentColor' } />
    </svg>
);
